/**
* DevExpress Analytics (property-grid\widgets\fonteditor\_fonts.js)
* Version:  23.1.7
* Build date: Dec 11, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
export var availableFonts = ko.observable({});
